export enum FeatureToggle {
  retailerCollections = 'rt_retailer_collections',
  // TODO: remove me once we launch instacart collections
  instacartCollectionsEnabled = 'rt_retailer_collections_use_instacart_collections',
  retailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
  // Check if retailer collections v2 is enabled for retailers storefront
  retailerCollectionsV2Preview = 'retailer_collections_v2_enabled',
  retailerCollectionsAdminV2 = 'rt_retailer_collections_admin_v2_enabled',
  storefront = 'rt_storefront',
  DynamiclyFedStaticCollections = 'rt_dynamicly_fed_static_collections',
  dynamicRulesProductInclusionExclusion = 'rt_dynamic_rules_product_inclusion_exclusion',
  flyersTermsApprovalRequired = 'rt_flyers_terms_approval_required',
  flyersImageAltText = 'rt_flyers_image_alt_text',
  flyerBulkCorrectionEnabled = 'rt_flyer_bulk_correction_enabled',
  flyerCopyFlyerClickableAreasEnabled = 'rt_flyer_copy_flyer_clickable_areas_enabled',
  dynamicCollectionInToolingPreview = 'rt_dynamic_collection_in_tooling_preview',
  flyerCreateFlyerEnabled = 'rt_flyer_create_flyer_enabled',
  lowerPriceDefinitions = 'rt_lower_price_definitions',
  adminRetailerCollections = 'rt_admin_retailer_collections',
  retailerCreateDigitalFlyerEnabled = 'rt_warehouse_create_digital_flyer',
}
